import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Reviews from "@/components/site/Reviews";
import ServiceArea from "@/components/site/ServiceArea";
import Contact from "@/components/site/Contact";
import FloatingCTA from "@/components/site/FloatingCTA";
import Footer from "@/components/site/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain" data-testid="app-root">
        <Header />
        <main>
          <Hero />
          <Ribbon />
          <Services />
          <Manifesto />
          <Reviews />
          <ServiceArea />
          <Contact />
        </main>
        <Footer />
        <FloatingCTA />
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0B1F3A",
              border: "1px solid rgba(255,196,0,0.3)",
              color: "#fff",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
